'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("userMenuLogoutButton", function (security, $session, $applications) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuLogoutButton.html"),
    link: function link($scope, $el, $attrs) {
      var user = $session.getUser();
      if ($applications.getCurrentAppId() !== 'INTRA' && _.includes(user.habilitations, 'INTRA_TAELYS')) {
        $scope.toIntra = true;
      }
      $scope.performLogout = function () {
        return security.exit();
      };
    }
  };
});
ngModule.directive("userMenuPrintModeButton", function ($print) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuPrintModeButton.html"),
    link: function link($scope, $el, $attrs) {
      $scope.enablePrintMode = function () {
        $print.enablePrint();
      };
    }
  };
});
ngModule.directive("userMenuGestionCompteButton", function ($print) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuGestionCompteButton.html"),
    link: function link($scope, $el, $attrs) {}
  };
});
ngModule.directive("userMenuAccountsSection", function ($http, security) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuAccountsSection.html"),
    link: function link($scope, $el, $attrs, stringUtils) {},
    controller: function controller($scope, stringUtils) {
      $scope.params = {
        search: null
      };
      $scope.authToken = security.getTokens().authenticationToken;
      $http.get('/rest/compte/comptes-accessibles').then(function (response) {
        $scope.filteredComptesAccessibles = $scope.comptesAccessibles = response.data;
        updateFiltered(true);
      });
      var updateFiltered = function updateFiltered(updateShowSearchTextBox) {
        $scope.filteredComptesAccessibles = _.extend({}, $scope.comptesAccessibles);
        $scope.filteredComptesAccessibles.parents = _.filter($scope.comptesAccessibles.parents, function (c) {
          return !$scope.params.search || stringUtils.containsIgnoringCaseAndAccents(c.nomClient, $scope.params.search);
        });
        $scope.filteredComptesAccessibles.enfants = _.filter($scope.comptesAccessibles.enfants, function (c) {
          return !$scope.params.search || stringUtils.containsIgnoringCaseAndAccents(c.nomClient, $scope.params.search);
        });
        $scope.filteredComptesAccessibles.autres = _.filter($scope.comptesAccessibles.autres, function (c) {
          return !$scope.params.search || stringUtils.containsIgnoringCaseAndAccents(c.nomClient, $scope.params.search);
        });

        // limite l'affichage du search au fait d'avoir + de 6 comptes
        if (updateShowSearchTextBox) {
          $scope.showSearchTextBox = $scope.filteredComptesAccessibles.parents.length + $scope.filteredComptesAccessibles.enfants.length + $scope.filteredComptesAccessibles.autres.length > 6;
        }
      };
      $scope.$watch('params', function (newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          updateFiltered(false);
        }
      }, true);
    }
  };
});
ngModule.directive("userMenuToolboxButton", function (toolboxService) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuToolboxButton.html"),
    link: function link($scope, $el, $attrs) {
      $scope.openToolbox = function () {
        toolboxService.openToolboxPopin();
      };
    }
  };
});
ngModule.directive("userMenuTaskManagerButton", function (userTaskService) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuTaskManagerButton.html"),
    link: function link($scope, $el, $attrs) {
      $scope.openTaskList = function () {
        userTaskService.openTaskList();
      };
    }
  };
});
ngModule.directive("userMenuGuideUtilisateurButton", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuGuideUtilisateur.html"),
    link: function link($scope, $el, $attrs) {}
  };
});
ngModule.directive("userMenuLab", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuLab.html"),
    link: function link($scope, $el, $attrs) {}
  };
});

/**
 * pour la partie subvention
 */
ngModule.directive("userMenuFormatMontants", function ($http) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: require("./userMenuFormatMontants.html"),
    link: function link($scope, $el, $attrs, stringUtils) {},
    controller: function controller($scope, contextService) {
      $scope.context = contextService.getContext();
      $scope.switchDecimales = function () {
        if (!$scope.context.cacherDecimales || $scope.context.cacherDecimales == false) {
          $scope.context.cacherDecimales = true;
        } else {
          $scope.context.cacherDecimales = false;
        }
      };
      $scope.changeUnite = function () {
        if ($scope.context.uniteAffichageMontant === 'K') {
          $scope.context.uniteAffichageMontant = 'M';
        } else if ($scope.context.uniteAffichageMontant === 'M') {
          $scope.context.uniteAffichageMontant = null;
        } else {
          $scope.context.uniteAffichageMontant = 'K';
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/topbar/user-menu/actions/userMenuActions.js
// module id = 3024
// module chunks = 13